import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchUserProfileAsync } from "@/store/redux/slices/user/user_slice";
import { updateUserInfo } from "@/store/redux/slices/auth/auth_slice";

/** Normalize profile API payload (object or { data: user }). */
const normalizeProfileUser = (payload) => {
  if (!payload) return null;
  if (payload.data && !Array.isArray(payload.data)) return payload.data;
  if (Array.isArray(payload.data)) return payload.data[0] ?? null;
  return payload;
};

const UserDataProvider = ({ children }) => {
  const dispatch = useDispatch();
  const isAuthenticated = useSelector((state) => state.auth.isAuthenticated);

  useEffect(() => {
    if (!isAuthenticated) return;

    const loadProfile = async () => {
      const result = await dispatch(fetchUserProfileAsync());
      if (!fetchUserProfileAsync.fulfilled.match(result)) return;

      const user = normalizeProfileUser(result.payload);
      if (!user) return;

      dispatch(
        updateUserInfo({
          fullname: user.fullname ?? "",
          email: user.email ?? "",
          phone: user.phone ?? "",
          userID: user._id ?? user.userID ?? "",
        }),
      );
    };

    loadProfile();
  }, [dispatch, isAuthenticated]);

  return children;
};

export default UserDataProvider;
